import { CustomTooltip } from '@features/common';
import ViewRangos from '@features/common/ViewRangosAGW/ViewRangos';
import { InputOptions } from '@features/filters/interfaces/filters.interfaces';
import { RangoCliente } from '@interfaces/firestore-documents.interfaces';
import { Add, ArrowBack } from '@mui/icons-material';
import { Button, Grid, GridSize, IconButton, Typography } from '@mui/material';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import FiltersContainer from '../FiltersContainer';
import useTitleHeaderContainerStyles from './TitleHeaderContainer.styles';

interface AddButtonProps {
	onClick: React.MouseEventHandler<HTMLButtonElement>;
	tooltip: string;
}

interface BackButtonProps {
	onClick: React.MouseEventHandler<HTMLButtonElement>;
}

interface Props {
	addButton?: AddButtonProps;
	backButton?: BackButtonProps;
	className?: string;
	counter?: number;
	id: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	inputs: InputOptions<any>[];
	title: React.ReactNode;
	rangosCliente: RangoCliente[];
}

const TitleHeaderContainer: React.FC<Props> = ({
	addButton,
	backButton,
	className,
	counter = 0,
	id,
	inputs,
	title,
	rangosCliente,
}) => {
	// States
	const [filtersSize, setFiltersSize] = useState<GridSize>('auto');
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isView, setIsView] = useState<boolean>(false);

	// Hooks
	const classes = useTitleHeaderContainerStyles();

	// Private functions

	function calculateWidth(): void {
		const containerLeftWidth = document.getElementById(`${id}-left`)?.clientWidth ?? 0;
		let containerRightWidth = 0;

		const children = document.getElementById(`${id}-filters-container`)?.children ?? [];
		if (children.length > 0) {
			for (let i = 0; i < children.length; i++) {
				const el = children[i];
				containerRightWidth += el.clientWidth;
			}
		}

		const containerWidth = document.getElementById(id)?.offsetWidth ?? 0;

		const setMaxWidth = containerLeftWidth + containerRightWidth + 30 >= containerWidth;
		setFiltersSize(setMaxWidth ? 12 : 'auto');
	}

	// Effects
	useEffect(() => {
		calculateWidth();
		window.onresize = calculateWidth.bind(this);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		calculateWidth();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isOpen]);

	const closeRanges = () => {
		setIsView(false);
	};

	return (
		<>
			{isView && <ViewRangos onClose={closeRanges} rangosCliente={rangosCliente} />}

			<Grid
				container
				alignItems="center"
				className={clsx(classes.root, className)}
				id={id}
				justifyContent="space-between"
				spacing={1}
			>
				<Grid item id={`${id}-left`}>
					<Grid container alignItems="center" style={{ gap: 6 }}>
						{backButton != undefined && (
							<Grid item>
								<button className={classes.backButton} onClick={backButton.onClick}>
									<ArrowBack />
								</button>
							</Grid>
						)}
						<Grid item>
							<Typography
								color="#003C82"
								fontFamily="Montserrat"
								fontSize={22}
								fontWeight={800}
								id={`${id}-text`}
							>
								{title}
							</Typography>
						</Grid>
						{addButton != undefined && (
							<Grid item>
								<CustomTooltip title={addButton.tooltip}>
									<IconButton
										id={`${id}-add-button`}
										onClick={addButton.onClick}
										size="small"
										sx={{ color: '#003C82', minWidth: 0 }}
									>
										<Add />
									</IconButton>
								</CustomTooltip>
							</Grid>
						)}
					</Grid>
				</Grid>
				<Grid item id={`${id}-left`} xs={filtersSize}>
					<Grid container spacing={1}>
						<Grid item xs={6}>
							<FiltersContainer
								counter={counter}
								id={id}
								inputs={inputs}
								isOpen={isOpen}
								setIsOpen={setIsOpen}
								name={'Filtro'}
							/>
						</Grid>
						<Grid item xs={6}>
							<div>
								<Button
									onClick={() => setIsView(true)}
									style={{
										textTransform: 'none',
									}}
									className={classes.buttonRange}
								>
									Rangos de Guías
								</Button>
							</div>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};

export default TitleHeaderContainer;
